import { useCallback, useEffect, useMemo, useState } from 'react';

// Resumen académico de un curso para mostrar el estado de cada alumno en tablas existentes.
// Si falla (sin permisos o sin red) no rompe la pantalla: devuelve el error y un mapa vacío.
const useResumenAcademico = (api, enabled = true) => {
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    if (!api || !enabled) return;
    setLoading(true);
    try {
      setResumen(await api.getResumen());
      setError('');
    } catch (err) {
      setResumen(null);
      setError(err?.message || 'No pudimos cargar el resumen académico.');
    } finally {
      setLoading(false);
    }
  }, [api, enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  const porAlumno = useMemo(
    () => new Map((resumen?.alumnos || []).map((alumno) => [alumno.idAlumno, alumno])),
    [resumen]
  );

  return { resumen, porAlumno, loading, error, reload };
};

export default useResumenAcademico;
